import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SeoStructuredData from '@/components/feature/SeoStructuredData';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const stats = [
    { value: '50万+', label: '注册用户', icon: 'ri-user-line' },
    { value: '2万+', label: '精选文章', icon: 'ri-article-line' },
    { value: '6个', label: '内容分类', icon: 'ri-folder-line' },
    { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
  ];

  const milestones = [
    { year: '2023', title: '平台创立', description: '久草社区正式上线，致力于打造优质内容聚合平台' },
    { year: '2024', title: '快速发展', description: '注册用户突破20万，日均活跃用户超过5万，内容生态初步成型' },
    { year: '2025', title: '生态完善', description: '上线6大内容分类，引入优质创作者，社区互动氛围浓厚' },
    { year: '2026', title: '全新升级', description: '全面优化用户体验，推出个性化推荐算法，内容质量持续提升' },
  ];

  const testimonials = [
    {
      name: '张先生',
      role: '资深用户',
      content: '久草社区是我每天必刷的平台，内容质量高，分类清晰，总能找到我感兴趣的文章。社区的讨论氛围也非常好。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20male%20professional%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20business%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=testimonial-avatar-01&orientation=squarish',
    },
    {
      name: '李女士',
      role: '内容创作者',
      content: '作为一名创作者，久草社区给了我很好的展示平台。编辑推荐机制很公平，优质内容确实能得到更多曝光。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20female%20content%20creator%2C%20clean%20white%20background%2C%20warm%20smile%2C%20creative%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=testimonial-avatar-02&orientation=squarish',
    },
    {
      name: '王同学',
      role: '大学生用户',
      content: '学习和健身板块对我帮助特别大。很多实用的教程和经验分享，让我在课余时间学到了很多课堂之外的知识。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20male%20student%2C%20clean%20white%20background%2C%20bright%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting&width=100&height=100&seq=testimonial-avatar-03&orientation=squarish',
    },
  ];

  const faqItems = [
    {
      question: '久草社区是什么？',
      answer: '久草社区是一个在线内容聚合与互动交流平台，汇聚海量精选资源，涵盖科技数码、生活娱乐、美食旅行、电影音乐、运动健身、学习教育六大分类，为用户提供优质的阅读和社区互动体验。',
    },
    {
      question: '如何注册久草社区账号？',
      answer: '您可以直接使用手机号或邮箱注册久草社区账号。注册完成后即可浏览所有公开内容，参与评论互动，收藏喜欢的文章。',
    },
    {
      question: '久草社区的内容来源是什么？',
      answer: '久草社区的内容来自平台邀请的优质创作者和用户自发投稿。所有内容都经过编辑团队审核，确保质量和原创性。我们致力于打造一个高质量的内容生态。',
    },
    {
      question: '如何成为久草社区的创作者？',
      answer: '如果您有优质原创内容想要分享，可以通过"关于我们"页面底部的联系方式联系我们的编辑团队。我们的编辑会评估您的内容质量和风格是否符合平台定位。',
    },
    {
      question: '久草社区有哪些内容分类？',
      answer: '久草社区目前涵盖六大内容分类：科技数码（前沿科技资讯与产品评测）、生活娱乐（生活方式与娱乐八卦）、美食旅行（美食探店与旅行攻略）、电影音乐（影视推荐与音乐分享）、运动健身（健身指南与赛事资讯）、学习教育（学习资源与技能提升）。',
    },
  ];

  return (
    <>
      <ScrollToTop />
      <SeoStructuredData
        type="Organization"
      />
      <SeoStructuredData
        type="WebPage"
        pageTitle="关于我们 - 久草社区"
        pageDescription="了解久草社区的品牌故事、发展历程、用户口碑和联系方式。久草社区是深受用户喜爱的在线内容聚合与互动交流平台。"
        pageUrl="https://jiucao.community/about"
        breadcrumbItems={[
          { name: '首页', url: 'https://jiucao.community' },
          { name: '关于我们', url: 'https://jiucao.community/about' },
        ]}
      />
      <SeoStructuredData
        type="FAQPage"
        faqItems={faqItems}
      />

      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100/70 border-b border-background-200/60">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-4">
              关于久草社区
            </h1>
            <p className="text-foreground-600 mt-2 max-w-2xl">
              汇聚海量精选资源、活跃社区讨论与多元兴趣圈子，致力于打造最优质的中文内容聚合平台
            </p>
          </div>
        </div>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                品牌故事
              </h2>
              <p className="text-foreground-700 leading-relaxed mb-4">
                久草社区创立于2023年，由一群热爱互联网和内容创作的年轻人共同发起。
                我们深知在信息爆炸的时代，找到高质量、有价值的内容变得越来越困难。
                因此，我们决定打造一个专注于内容品质的聚合平台。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                久草社区的名字寓意"历久弥新，草根力量"。我们相信，
                优秀的创作不应该被埋没在信息的海洋中。无论是专业作者还是普通用户，
                只要内容有价值，就应该被更多人看到。
              </p>
              <p className="text-foreground-700 leading-relaxed">
                经过三年多的发展，久草社区已经从一个小型内容分享站点，
                成长为拥有50万注册用户的内容聚合平台。我们始终坚持"内容为王"的理念，
                为读者提供优质的阅读体验，为创作者提供公平的展示机会。
              </p>
            </div>
            <div className="rounded-xl overflow-hidden">
              <div className="w-full h-[320px] md:h-[400px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20cozy%20creative%20office%20workspace%20with%20team%20collaboration%2C%20warm%20natural%20lighting%2C%20wooden%20desks%2C%20indoor%20plants%2C%20bookshelves%2C%20creative%20atmosphere%2C%20editorial%20workspace%20photography%20with%20relaxed%20authentic%20vibe&width=800&height=600&seq=about-brand-story&orientation=landscape"
                  alt="久草社区团队办公环境"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100/70 py-10 md:py-14">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
              平台数据
            </h2>
            <p className="text-foreground-600 text-center mb-8">用数字说话，见证我们的成长</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 text-center"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
            发展历程
          </h2>
          <p className="text-foreground-600 text-center mb-8">一路走来，感恩有你</p>
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
            <div className="space-y-8">
              {milestones.map((item, index) => (
                <div
                  key={item.year}
                  className={`relative flex flex-col md:flex-row gap-4 md:gap-8 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-12 md:pl-0 md:px-8`}>
                    <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 inline-block text-left max-w-md">
                      <span className="text-xs font-bold text-accent-600 bg-accent-100 px-2.5 py-0.5 rounded-full">
                        {item.year}
                      </span>
                      <h3 className="font-heading text-base font-semibold text-foreground-950 mt-2 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600">{item.description}</p>
                    </div>
                  </div>
                  <div className="absolute left-4 md:left-1/2 top-6 w-3 h-3 rounded-full bg-accent-500 md:-translate-x-1.5"></div>
                  <div className="flex-1 hidden md:block"></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100/70 py-10 md:py-14">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
              用户口碑
            </h2>
            <p className="text-foreground-600 text-center mb-8">听听用户怎么说</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((item) => (
                <div
                  key={item.name}
                  className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <i className="ri-double-quotes-l text-accent-400 text-2xl"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{item.content}</p>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-200/40">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                      <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
            联系我们
          </h2>
          <p className="text-foreground-600 text-center mb-8">有任何问题或建议，欢迎与我们取得联系</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">电子邮箱</h3>
              <p className="text-sm text-foreground-600">contact@jiucao.community</p>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-customer-service-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">在线客服</h3>
              <p className="text-sm text-foreground-600">工作日 9:00 - 18:00</p>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className="ri-map-pin-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">公司地址</h3>
              <p className="text-sm text-foreground-600">中国·北京</p>
            </div>
          </div>
        </section>

        <section className="bg-background-100/70 py-10 md:py-14">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-2">
              常见问题
            </h2>
            <p className="text-foreground-600 text-center mb-8">快速了解久草社区</p>
            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <details
                  key={index}
                  className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-100/50 transition-colors">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              加入久草社区
            </h2>
            <p className="text-foreground-600 mb-6 max-w-lg mx-auto">
              发现优质内容，结交志同道合的朋友，享受极致的社区互动体验
            </p>
            <Link
              to="/"
              className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap inline-block"
            >
              立即开始浏览
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}